module.exports = __webpack_public_path__ + "resources/2.2.2/media/logo-qobuz.630f9c4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/logo-qobuz.jpg
// module id = 962
// module chunks = 0